/**
 * Bandeau de la page d'accueil : téléchargement de SmartLawyer Desktop.
 * Bouton direct vers le .dmg (Apple Silicon / Intel) + lien vers /desktop.
 */
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const DMG = {
  arm: '/public/downloads/SmartLawyer-mac-arm64.dmg',
  intel: '/public/downloads/SmartLawyer-mac-x64.dmg'
};

export function DesktopPromoSection() {
  const { t } = useTranslation();
  return (
    <section className="py-16 bg-background border-t border-border">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="rounded-3xl bg-gradient-to-br from-slate-950 via-indigo-950 to-violet-950 text-white p-8 sm:p-12 flex flex-col md:flex-row md:items-center gap-8 overflow-hidden relative">
          <img
            src="/public/smartlawyer_animated.svg"
            alt=""
            aria-hidden="true"
            className="absolute -right-24 -bottom-32 w-[420px] h-[420px] opacity-10 pointer-events-none select-none"
          />
          <div className="relative flex-1">
            <span className="inline-block text-[10px] font-bold uppercase tracking-widest px-2.5 py-1 rounded-full bg-white/10 text-violet-200">
              {t('desktop.promo.badge')} · macOS
            </span>
            <h2 className="mt-4 text-2xl sm:text-3xl font-bold">
              {t('desktop.promo.title')}
            </h2>
            <p className="mt-3 text-indigo-100 max-w-xl">{t('desktop.promo.text')}</p>
          </div>
          <div className="relative flex flex-col gap-2 md:items-end shrink-0">
            <a
              href={DMG.arm}
              download
              className="px-6 py-3 rounded-xl bg-violet-500 hover:bg-violet-400 font-semibold text-center"
            >
               {t('desktop.download.mac_arm')}
            </a>
            <div className="flex gap-4 text-sm text-indigo-200 justify-center md:justify-end">
              <a href={DMG.intel} download className="underline hover:text-white">
                {t('desktop.download.mac_intel')}
              </a>
              <Link to="/desktop" className="underline hover:text-white">
                {t('desktop.promo.more')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
